import { Facebook, Instagram, Twitter } from "./icons"

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-200">
      <div className="container mx-auto px-4 md:px-6 py-6">
        <div className="flex flex-col items-center justify-center gap-4">
          {/* Social Icons */}
          <div className="flex space-x-4 mt-4 gap-20">
            <a href="https://www.facebook.com/FoodUniverse.GlenRock" className="text-gray-400 hover:text-white">
              <Facebook className="h-7 w-7" />
              <span className="sr-only">Facebook</span>
            </a>
          </div>
        </div>

        {/* Contact Numbers */}
        <div className="flex flex-row justify-center mt-8 text-center text-md text-gray-400 gap-24">
          <p>Glen Rock, NJ: (201) 345-2261</p>
          <p>Paterson, NJ: (862) 267-2141</p>
        </div>

        {/* Bottom Border */}
        <div className="border-t border-gray-800 mt-8 pt-6 text-sm text-gray-400">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>© 2025 Food Universe. All rights reserved.</p>
            <div className="flex gap-4 mt-4 md:mt-0"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer
